// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CreditCardPlusSvg from '@rsuite/icon-font/lib/application/CreditCardPlus';
var CreditCardPlus = createSvgIcon({
  as: CreditCardPlusSvg,
  ariaLabel: 'credit card plus',
  category: 'application',
  displayName: 'CreditCardPlus'
});
export default CreditCardPlus;